package music.limasoul.shared.network.domain.model

import io.ktor.http.HttpStatusCode

open class AppException(val status: HttpStatusCode, message: String) : RuntimeException(message)

object AuthException : AppException(HttpStatusCode.Unauthorized, "Unauthorized")

object ForbiddenException : AppException(HttpStatusCode.Forbidden, "Access forbidden")

object TokenIsEmptyException : AppException(HttpStatusCode.BadRequest, "Token is empty")

object UserNotFoundException : AppException(HttpStatusCode.BadRequest, "User not found")

object IdNotFoundException : AppException(HttpStatusCode.BadRequest, "'id' not found")

object AlreadyBookedException : AppException(HttpStatusCode.Forbidden, "Already booked.")

object NotOwnerException : AppException(HttpStatusCode.Forbidden, "Your are not the owner of this reservation")

object NotBookedException : AppException(HttpStatusCode.BadRequest, "Event member is not booked")

fun idNotFound(): Nothing =
    throw IdNotFoundException

fun userNotFound(): Nothing =
    throw UserNotFoundException